import apiFetch from '../apiFetch'
export default function (token, conditionDocumentalId) {
  return apiFetch({ endPoint: `conditionDocumental/${conditionDocumentalId}`, method: 'DELETE', body: null, token: token })
}
